<!--
 * @version: V1.0.0
 * @Date: 2023-08-14 16:25:54
 * @LastEditors: lzq
 * @LastEditTime: 2024-01-29 10:48:30
 * @company: 睿展数据
 * @FilePath: \udi-wms-client\src\views\antiFake\supervisor\components\addOrEdit.vue
 * @Descripttion:
-->
<!--  -->
<template>
  <el-dialog v-loading.fullscreen="loading" top="50px" :append-to-body="true" :title="supervisorInfo.id ? '编辑监管员' : '新增监管员'"
    :visible="visible" width="450px" :destroy-on-close="true" :wrapper-closable="false" :show-close="false"
    :close-on-press-escape="false" :close-on-click-modal="false">
    <el-form ref="form" :rules="rules" :model="form" label-width="120px">
      <el-form-item label="监管员姓名" prop="name">
        <el-input v-model="form.name" :maxlength="20"></el-input>
      </el-form-item>
      <el-form-item label="手机号码" prop="phone">
        <el-input v-model="form.phone"></el-input>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="$emit('close')">取 消</el-button>
      <el-button type="primary" @click="submit"> 确 定 </el-button>
    </span>
  </el-dialog>
</template>

<script>
import {
  updateSupervisor,
  addSupervisor
} from '@/api/antiFake/supervisor'
export default {
  name: 'AddOrEditSupervisor',
  props: {
    visible: {
      type: Boolean,
      default() {
        return false
      }
    },
    supervisorInfo: {
      type: Object,
      default() {
        return {}
      }
    },
  },
  data() {
    // 这里存放数据
    return {
      loading: false,
      form: {
        name: null,
        phone: null,
        status:'1'
      },
      rules: {
        name: [
          {
            required: true,
            message: '请输入监管员姓名',
            trigger: ['change', 'blur']
          }
        ],
        phone: [
          {
            required: true,
            message: '请输入手机号',
            trigger: ['change', 'blur']
          }, {
            pattern: /^(?:(?:\+?86)?1[3-9]\d{9}|0[1-9]\d{1,2}-?\d{7,8})$/,
            message: '请输入正确的电话格式',
            trigger: ['change', 'blur']
          }
        ],
      }
    }
  },
  created() {
    console.log(this.supervisorInfo);
    if (this.supervisorInfo.id) {
      this.form = JSON.parse(JSON.stringify(this.supervisorInfo))
    }
  },
  // 方法集合
  methods: {
    // 保存
    submit() {
      this.$refs.form.validate((valid) => {
        if (!valid) return
        this.loading = true
        const params = JSON.parse(JSON.stringify(this.form));
        if (this.supervisorInfo.id) {
          updateSupervisor(params).then(() => {
            this.$emit('close')
          }).finally(() => {
            this.loading = false
          })
        } else {
          addSupervisor(params).then(() => {
            this.$emit('close')
          }).finally(() => {
            this.loading = false
          })
        }

      })
    }
  }
}
</script>
